import {OrderType} from '../../types/order.type';
import {CampaignsSortType} from '../../types/campaigns.type';
import {CampaignTypeEnum} from '@shared/enums/campaign-type.enum';

export class FetchCampaigns {
  static readonly type = '[Campaigns tv-owner] Get all campaigns';

  constructor(public page?: number) {
  }
}

export class SortCampaigns {
  static readonly type = '[Campaigns tv-owner] Sort campaigns';

  constructor(public payload: {
    sort: CampaignsSortType
    order: OrderType
  }) {
  }
}

export class GetCampaignsByType {
  static readonly type = '[Campaigns tv-owner] Get campaigns by type';

  constructor(public type: CampaignTypeEnum) {
  }
}

export class SearchCampaigns {
  static readonly type = '[Campaigns tv-owner] Search campaigns';

  constructor(public value: string) {
  }
}

export class SetCampaignsPage {
  static readonly type = '[Campaigns tv-owner] Set page campaigns';

  constructor(public page: number) {
  }
}

export class EnableCampaignsLoader {
  static readonly type = '[Campaigns tv-owner] Turn on loader';
}

export class DisableCampaignsLoader {
  static readonly type = '[Campaigns tv-owner] Turn off loader';
}
